'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isFileAccept = isFileAccept;
exports.beforeUpload = beforeUpload;
exports.beforeUploadForDesigner = beforeUploadForDesigner;
exports.registerFile = registerFile;
exports.uploadResultFormatter = uploadResultFormatter;
exports.getImageDimensions = getImageDimensions;
exports.transformUrl = transformUrl;

var _next = require('@alifd/next');

var _formFieldUtils = require('../formFieldUtils');

var _service = require('./service');

var _lodash = require('lodash');

// 文件后缀判断，是否能够被允许接收
function isFileAccept(url, accept) {
  if (!url) {
    return false;
  }
  var ext = url.substring(url.lastIndexOf('.'));
  // 根据传入的accept对url后缀进行校验
  if (accept && accept !== '*') {
    var acceptArr = accept.split(',');
    return acceptArr.indexOf(ext.toLocaleLowerCase()) > -1;
  }
  return true;
}

function beforeUpload(file, options) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var fileUuidName = (0, _formFieldUtils.uuidFileName)(file.name);
  var obj = _extends({
    fileName: fileUuidName
  }, config);
  return new Promise(function (resolve, reject) {
    (0, _service.getFileUploadPolicy)(obj).then(function (data) {
      var host = data.host,
          signature = data.signature,
          policy = data.policy,
          dir = data.dir,
          accessKeyId = data.accessKeyId,
          fileKey = data.fileKey;

      if ((0, _lodash.isNil)(file.name)) {
        reject();
      }
      var key = fileKey || dir + '/' + fileUuidName;
      var prefix = host.endsWith('/') ? host : host + '/';

      file.uuidName = fileUuidName;
      file.ossUrl = '' + prefix + key;
      file.fileKey = key;

      options.action = host;
      options.withCredentials = false;
      options.data = {
        key: key,
        policy: policy,
        OSSAccessKeyId: accessKeyId,
        signature: signature
      };
      options.headers = config.requestHeader || {};
      resolve(options);
    }).catch(function (e) {
      _next.Message.error('\u6587\u4EF6' + file.name + '\u4E0A\u4F20\u5931\u8D25');
      reject();
    });
  });
}

function beforeUploadForDesigner(file, options, config) {
  return new Promise(function (resolve, reject) {
    (0, _service.getFileUploadPolicyForDesigner)(config).then(function (data) {
      var host = data.host,
          signature = data.signature,
          policy = data.policy,
          dir = data.dir,
          accessKeyId = data.accessKeyId;

      if ((0, _lodash.isNil)(file.name)) {
        reject();
      }
      var fileUuidName = (0, _formFieldUtils.uuidFileName)(file.name);
      var key = dir + '/' + fileUuidName;

      file.uuidName = fileUuidName;
      file.ossUrl = '' + host + key;

      options.action = host;
      options.withCredentials = false;
      options.data = {
        key: key,
        policy: policy,
        OSSAccessKeyId: accessKeyId,
        signature: signature
      };
      resolve(options);
    }).catch(function () {
      reject();
    });
  });
}

function registerFile(fileName, filePath) {
  return (0, _service.form_registerFileUsingPost)(fileName, filePath).catch(function () {
    // Message.info('注册文件失败');
  });
}

function uploadResultFormatter(res, file) {
  return {
    success: true,
    url: file.ossUrl,
    fileKey: file.fileKey,
    name: file.name
  };
}

function getImageDimensions(file) {
  return new Promise(function (resolve, reject) {
    var image = new Image();
    image.onload = function () {
      resolve({ width: image.width, height: image.height });
    };
    image.src = file;
  });
}

/**
 * 转换协议头，下游系统需要完整的协议头部
 * @param {*} url
 */
function transformUrl(url) {
  var protocol = window.location.protocol;
  return url && url.replace(/http[s]{0,1}:(.*)/, protocol + '$1');
}